<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Danh sách kỳ nghỉ" :link="[{ text: 'Kỳ nghỉ', href: '../holiday' }]" />
      </div>
      <div class="flex-center">
        <v-btn
          depressed
          dark
          color="#0D47A1"
          @click.stop="createState = !createState"
        >
          <v-icon left>add</v-icon>
          Thêm kỳ nghỉ
        </v-btn>
      </div>
    </div>
    <v-card v-if="$auth.role.type !== 'teacher'" outlined class="pa-6 mx-4 mb-6 elevation-0">
      <HolidayFilter :windowWidth="windowWidth" @onFilterChanged="refresh" />
    </v-card>
    <v-card outlined class="mx-4 elevation-0">
      <HolidayTable ref="table" @onEdit="onEditHoliday" />
    </v-card>

    <DetailHolidayDialog ref="detail-holiday-dialog" :state="createState" @done="refresh" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import StaffFilter from '@/modules/staff/StaffFilter.vue'
import HolidayTable from '@/views/timetable/HolidayTable.vue'
import DetailHolidayDialog from '@/views/timetable/components/DetailHolidayDialog.vue'
import HolidayFilter from '@/modules/timeTable/HolidayFilter.vue'

export default {
  components: {
    HolidayFilter,
    HolidayTable,
    DetailHolidayDialog,
    Breadcrumbs,
    StaffFilter,
  },
  props: {
    role: String,
  },
  data() {
    return {
      headers: [],
      search: '',
      status: null,
      isLoading: false,
      createState: false,
      windowWidth: window.innerWidth,
    }
  },
  async created() {
    this.isLoading = true
    await this.fetchRoles()
  },
  computed: {
    filters() {
      return [{ key: 'block', value: this.status }]
    },
  },
  methods: {
    ...mapActions('role', ['fetchRoles']),
    refresh(query) {
      this.$refs.table.refresh(query)
    },
    onEditHoliday(data) {
      this.$refs['detail-holiday-dialog'].openDialog(data)
    }
  }
}
</script>
